import { yupResolver } from "@hookform/resolvers/yup";
import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { KHMCTU_DEFAULT } from "constants/TaxDeductRegisterConstant";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import { getCurrentKhctu } from "pages/TaxDeduct/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  resetSearchInvoiceErrorInvoices,
  searchInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import {
  invoiceTypeMode,
  KyHieuMauHoaDonList,
  tableFormateDate,
} from "./utils";

const SearchInvoiceTaxDeduct = props => {
  const {
    isOpenModal,
    toggleModal,
    dataSearchInvoice,
    setDataSearchInvoice,
    addNewLine,
    isTaxDeduct = true,
  } = props;

  const object = isTaxDeduct ? "Chứng từ" : "Hóa đơn";

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { addToast } = useToasts();

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingSearchInvoice,
    errorSearchInvoice,
    searchInvoice: errorInvoicesSearchInvoice,
  } = errorInvoices;

  const Dashboard = useSelector(state => state.Dashboard);
  const { listBuOfTenant, listBuStore } = Dashboard;

  const [resultSearch, setResultSearch] = useState(null);

  const schema = yup.object().shape({
    khmhdon: yup.object(),
    khhdon: yup
      .string()
      .required(
        t("form.validate.required", {
          title: isTaxDeduct ? t("form.khctu") : t("form.khhdon"),
        })
      )
      .max(100, t("form.validate.char_max", { max: 100 })),
    shdon: yup
      .string()
      .required(
        t("form.validate.required", {
          title: isTaxDeduct ? t("form.sctu") : t("form.so_hoa_don"),
        })
      )
      .matches(/^[0-9]+$/, t("form.validate.integer")),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      khmhdon: undefined,
      khhdon: "",
      shdon: "",
    },
  });

  // Modal Closed
  useEffect(() => {
    if (!isOpenModal) {
      setResultSearch(null);
      reset({
        khmhdon: undefined,
        khhdon: "",
        shdon: "",
      });
      dispatch(resetSearchInvoiceErrorInvoices());
    } else {
      if (isTaxDeduct) {
        const khctu = getCurrentKhctu();
        setValue("khmhdon", {
          value: KHMCTU_DEFAULT,
          label: KHMCTU_DEFAULT,
        });
        setValue("khhdon", khctu);
      }
    }
  }, [dispatch, isOpenModal]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesSearchInvoice && errorInvoicesSearchInvoice.success) {
      if (errorInvoicesSearchInvoice.data) {
        if (isTaxDeduct) {
          const { ttchung_msctu, ttchung_khctu, ttchung_sctu, ttchung_nlap } =
            errorInvoicesSearchInvoice.data;
          setResultSearch({
            ttchung_khmshdon: ttchung_msctu,
            ttchung_khhdon: ttchung_khctu,
            ttchung_shdon: ttchung_sctu,
            ttchung_nlap: ttchung_nlap,
          });
        } else {
          setResultSearch(errorInvoicesSearchInvoice.data);
        }
      }
      dispatch(resetSearchInvoiceErrorInvoices());
    }
  }, [dispatch, errorInvoicesSearchInvoice]);

  // Error Dispatch
  useEffect(() => {
    if (errorSearchInvoice) {
      if (
        errorSearchInvoice.status &&
        errorSearchInvoice.status === "NOT_FOUND"
      ) {
      } else {
        addToast(
          formConvertErrorMessage(
            errorSearchInvoice.message ||
              (isTaxDeduct
                ? t("message.search_tax_deduct", {
                    status: t("message.error"),
                  })
                : t("message.search_invoice", {
                    status: t("message.error"),
                  })),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
    }
  }, [addToast, errorSearchInvoice, t]);

  const onSubmit = values => {
    const valuesSearch = isTaxDeduct
      ? {
          khctu: values.khhdon,
          sctu: values.shdon,
        }
      : {
          khhdon: values.khhdon,
          shdon: values.shdon,
        };
    dispatch(searchInvoiceErrorInvoices(valuesSearch));
    setResultSearch(null);
  };

  const khmhdonHandler = () => {
    let khhdonPrefix = "";
    const ye = new Intl.DateTimeFormat("en", { year: "2-digit" }).format(
      new Date()
    );

    const buTenant = localStorage.getItem("BU_STORE_HEADER");
    let value = null;
    let dataBu = null;
    if (listBuStore && listBuStore.length > 0) {
      value = listBuStore.find(item => item.value === buTenant);
      dataBu = value;
    } else {
      value = listBuOfTenant.find(item => item.code === buTenant);
      dataBu = value && value.itemBU;
    }

    switch (String(dataBu.invoice_type)) {
      case invoiceTypeMode.NONE_CODE:
        khhdonPrefix += "K";
        break;
      case invoiceTypeMode.HAVE_CODE:
        khhdonPrefix += "C";
        break;
      default:
        break;
    }

    khhdonPrefix += String(ye);

    const khmhdonValue = getValues("khmhdon");
    const prefixFind = KyHieuMauHoaDonList.find(
      item => item.value === khmhdonValue.value
    );
    if (prefixFind) {
      khhdonPrefix += prefixFind.prefix;
    }

    setValue("khhdon", khhdonPrefix, { shouldValidate: true });
    setFocus("khhdon");
  };

  const addToInvoiceListHandler = () => {
    const resultFind = dataSearchInvoice.find(
      item => Number(item.id) === Number(resultSearch.id)
    );
    if (resultFind) {
      addToast(`${object} này đã được thêm vào`, {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      addToast("Thêm vào danh sách thành công", {
        appearance: "success",
        autoDismiss: true,
      });
      setDataSearchInvoice([...dataSearchInvoice, resultSearch]);

      const khmhdonFind = KyHieuMauHoaDonList.find(
        item => item.value === resultSearch.ttchung_khmshdon
      );

      const dateNgayLap =
        resultSearch.ttchung_nlap &&
        new Date(Number(resultSearch.ttchung_nlap) * 1000).toString() !==
          "Invalid Date"
          ? [new Date(Number(resultSearch.ttchung_nlap) * 1000)]
          : [];

      addNewLine({
        id_invoice: resultSearch.id,
        ma_cqt_cap: resultSearch.mccqt,
        khmhdon: khmhdonFind
          ? khmhdonFind
          : resultSearch.ttchung_khmshdon
          ? {
              value: resultSearch.ttchung_khmshdon,
              label: resultSearch.ttchung_khmshdon,
            }
          : undefined,
        khhdon: resultSearch.ttchung_khhdon,
        so_hoa_don: Number(resultSearch.ttchung_shdon),
        ngay_lap_hdon: dateNgayLap,
        tchat_thong_bao: undefined,
        ly_do: "",
      });
    }
  };

  const tableInvoiceSearch = (
    <Table className="table table-bordered">
      <thead>
        <tr>
          <th>Mã CQT cấp</th>
          <th>Ký hiệu mẫu hóa đơn</th>
          <th>Ký hiệu hóa đơn</th>
          <th>Số hóa đơn điện tử</th>
          <th>Ngày lập hóa đơn</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{resultSearch?.mccqt}</td>
          <td>{resultSearch?.ttchung_khmshdon}</td>
          <td>{resultSearch?.ttchung_khhdon}</td>
          <td>{resultSearch?.ttchung_shdon}</td>
          <td>{tableFormateDate(resultSearch?.ttchung_nlap)}</td>
        </tr>
      </tbody>
    </Table>
  );

  const tableTaxDeductSearch = (
    <Table className="table table-bordered">
      <thead>
        <tr>
          {/* <th>Mã CQT cấp</th> */}
          <th>Ký hiệu mẫu chứng từ</th>
          <th>Ký hiệu chứng từ</th>
          <th>Số chứng từ</th>
          <th>Ngày lập chứng từ</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {/* <td>{resultSearch?.mccqt}</td> */}
          <td>{resultSearch?.ttchung_khmshdon}</td>
          <td>{resultSearch?.ttchung_khhdon}</td>
          <td>{resultSearch?.ttchung_shdon}</td>
          <td>{tableFormateDate(resultSearch?.ttchung_nlap)}</td>
        </tr>
      </tbody>
    </Table>
  );

  const tableInvoiceSelected = (
    <Table className="table table-bordered">
      <thead>
        <tr>
          <th>Mã CQT cấp</th>
          <th>Ký hiệu mẫu hóa đơn</th>
          <th>Ký hiệu hóa đơn</th>
          <th>Số hóa đơn điện tử</th>
          <th>Ngày lập hóa đơn</th>
        </tr>
      </thead>
      <tbody>
        {dataSearchInvoice.map(item => {
          return (
            <tr key={item.id}>
              <td>{item.mccqt}</td>
              <td>{item.ttchung_khmshdon}</td>
              <td>{item.ttchung_khhdon}</td>
              <td>{item.ttchung_shdon}</td>
              <td>{tableFormateDate(item.ttchung_nlap)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  const tableTaxDeductSelected = (
    <Table className="table table-bordered">
      <thead>
        <tr>
          {/* <th>Mã CQT cấp</th> */}
          <th>Ký hiệu mẫu chứng từ</th>
          <th>Ký hiệu chứng từ</th>
          <th>Số chứng từ</th>
          <th>Ngày lập chứng từ</th>
        </tr>
      </thead>
      <tbody>
        {dataSearchInvoice.map(item => {
          return (
            <tr key={item.id}>
              {/* <td>{item.mccqt}</td> */}
              <td>{item.ttchung_khmshdon}</td>
              <td>{item.ttchung_khhdon}</td>
              <td>{item.ttchung_shdon}</td>
              <td>{tableFormateDate(item.ttchung_nlap)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  return (
    <React.Fragment>
      <Modal
        size="xl"
        contentClassName="select-job-modal"
        className="exampleModal"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {isTaxDeduct
              ? t("title.search_tax_deduct")
              : t("title.search_invoice")}
          </ModalHeader>
          <ModalBody>
            {!isTaxDeduct ? (
              <Row>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="khmhdon">{t("form.khmhdon")}</Label>
                    <Controller
                      control={control}
                      name="khmhdon"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.khmhdon"),
                          })}
                          options={
                            KyHieuMauHoaDonList &&
                            KyHieuMauHoaDonList.length > 0
                              ? KyHieuMauHoaDonList.map(item => ({
                                  value: item.value,
                                  label: item.label,
                                }))
                              : []
                          }
                          onChange={data => {
                            field.onChange(data);
                            khmhdonHandler();
                          }}
                          classNamePrefix="select2-selection"
                        />
                      )}
                    />
                    {errors.khmhdon && (
                      <MessageFormValidate error={errors.khmhdon.message} />
                    )}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="khhdon">
                      {t("form.khhdon")} <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="khhdon"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${formValidate(
                            errors,
                            touchedFields,
                            "khhdon"
                          )}`}
                          onChange={data => {
                            field.onChange(data.target.value.toUpperCase());
                          }}
                          placeholder={t("placeholder.enter", {
                            title: t("form.khhdon"),
                          })}
                        />
                      )}
                    />
                    {errors.khhdon && (
                      <MessageFormValidate error={errors.khhdon.message} />
                    )}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="shdon">
                      {t("form.shdon")} <span className="text-danger">*</span>
                    </Label>
                    <input
                      type="number"
                      className={`form-control ${formValidate(
                        errors,
                        touchedFields,
                        "shdon"
                      )}`}
                      placeholder={t("placeholder.enter", {
                        title: t("form.shdon"),
                      })}
                      {...register("shdon")}
                    />
                    {errors.shdon && (
                      <MessageFormValidate error={errors.shdon.message} />
                    )}
                  </FormGroup>
                </Col>
              </Row>
            ) : (
              <>
                <Row>
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="khmhdon">{t("form.khmctu")}</Label>
                      <Controller
                        control={control}
                        name="khmhdon"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.khmctu"),
                            })}
                            isDisabled={isTaxDeduct}
                            options={
                              !isTaxDeduct
                                ? KyHieuMauHoaDonList?.map(item => ({
                                    value: item.value,
                                    label: item.label,
                                  }))
                                : []
                            }
                            classNamePrefix="select2-selection"
                          />
                        )}
                      />
                      {errors.khmhdon && (
                        <MessageFormValidate error={errors.khmhdon.message} />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="khctu">
                        {t("form.khctu")} <span className="text-danger">*</span>
                      </Label>
                      <Controller
                        control={control}
                        name="khhdon"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className={`form-control ${formValidate(
                              errors,
                              touchedFields,
                              "khhdon"
                            )}`}
                            onChange={data => {
                              field.onChange(data.target.value.toUpperCase());
                            }}
                            placeholder={t("placeholder.enter", {
                              title: t("form.khctu"),
                            })}
                          />
                        )}
                      />
                      {errors.khhdon && (
                        <MessageFormValidate error={errors.khhdon.message} />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="sctu">
                        {t("form.sctu")} <span className="text-danger">*</span>
                      </Label>
                      <input
                        type="number"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "shdon"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.sctu"),
                        })}
                        {...register("shdon")}
                      />
                      {errors.shdon && (
                        <MessageFormValidate error={errors.shdon.message} />
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </>
            )}
            <Row className="justify-content-end">
              <Col className="col-auto">
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  disabled={loadingSearchInvoice}
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="fas fa-search label-icon" />
                  {t("form.search")}
                </Button>
              </Col>
            </Row>
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Kết quả:</Label>
              </Col>
              {loadingSearchInvoice ? (
                <LoadingTableNormal countColumn="4" countRow="1" />
              ) : resultSearch && Object.keys(resultSearch).length > 0 ? (
                <React.Fragment>
                  <Col>
                    {isTaxDeduct ? tableTaxDeductSearch : tableInvoiceSearch}
                  </Col>
                  <Col className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary btn-label"
                      onClick={addToInvoiceListHandler}
                    >
                      <i className="fas fa-plus fa-lg label-icon" />
                      Thêm vào danh sách {object}
                    </button>
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {errorSearchInvoice &&
                    errorSearchInvoice.status &&
                    errorSearchInvoice.status === "NOT_FOUND" && (
                      <Col>
                        <div className="alert alert-warning" role="alert">
                          <span className="pe-1">
                            <i className="fas fa-exclamation-circle fa-lg"></i>
                          </span>
                          <span>Không tìm thấy {object}</span>
                        </div>
                      </Col>
                    )}
                </React.Fragment>
              )}
            </Row>

            <hr />
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Danh sách {object} đã chọn :</Label>
              </Col>
              {dataSearchInvoice && dataSearchInvoice.length > 0 ? (
                <React.Fragment>
                  <Col>
                    {isTaxDeduct
                      ? tableTaxDeductSelected
                      : tableInvoiceSelected}
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col>
                    <div className="alert alert-info" role="alert">
                      <span className="pe-1">
                        <i className="fas fa-exclamation-circle fa-lg"></i>
                      </span>
                      <span>Chưa có {object} nào được chọn</span>
                    </div>
                  </Col>
                </React.Fragment>
              )}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModal}
                >
                  {t("form.close")}
                </button>
              </Col>
            </Row>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

SearchInvoiceTaxDeduct.propTypes = {
  // dataDetail: PropTypes.object.isRequired,
  isTaxDeduct: PropTypes.bool,
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataSearchInvoice: PropTypes.array.isRequired,
  setDataSearchInvoice: PropTypes.func.isRequired,
  addNewLine: PropTypes.func.isRequired,
};

SearchInvoiceTaxDeduct.defaultProps = {
  isTaxDeduct: false,
  // dataDetail: {},
  isOpenModal: false,
  dataSearchInvoice: [],
};

export default SearchInvoiceTaxDeduct;
